import { REGISTRATION_ROLES } from "../registration/constants"

export const getAssignConfig = (role) => ({
  target_role: REGISTRATION_ROLES[REGISTRATION_ROLES._getKey(role)].str
})
